import React from "react";
import servicio_1 from "../../img/icon_servicio_1.png";
import servicio_2 from "../../img/icon_servicio_2.png";
import servicio_3 from "../../img/icon_servicio_3.png";
import servicio_4 from "../../img/icon_servicio_4.png";

export const ServiciosAdicionalesHome = () => {
    return (
        <div className="pt-8 mt-8 w-full bg-[#E7E8EA] bg-opacity-20 rounded-3xl pb-10 ">
            <div className="3xl:w-2/3 2xl:w-3/4 lg:w-4/5 w-5/6 mx-auto">
                <div className="text-[#071829] 2xl:text-4xl xl:text-3xl text-2xl font-bold md:w-2/5  ">
                    Conoce algunos de nuestros Servicios Adicionales
                </div>
                <div className="text-[#071829] 2xl:text-xl xl:text-base lg:text-base md:text-sm text-xs  mt-5  md:w-2/3 ">
                    Potencia tu alojamiento con servicios exclusivos que
                    facilitan y optimizan toda tu gestión.
                </div>

                <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-10 gap-5 xl:mt-10 lg:mt-7 mt-5">
                    <div className="py-8 px-8 rounded-2xl bg-white">
                        <img
                            className="h-12 w-12"
                            src={servicio_1}
                            alt="servicio_1"
                        />
                        <div className="xl:text-2xl lg:text-xl text-lg font-bold text-[#181C39] mt-2 ">
                            Manejo Comercial y Operativa
                        </div>
                        <div className=" 2xl:text-base lg:text-sm text-xs text-[#181C39] mt-3 ">
                            Optimizamos la gestión de tu negocio con procesos
                            eficientes y soluciones estratégicas.
                        </div>
                    </div>

                    <div className="py-5 px-5 rounded-2xl bg-white">
                        <img
                            className="h-12 w-12"
                            src={servicio_2}
                            alt="servicio_2"
                        />
                        <div className="xl:text-2xl lg:text-xl text-lg font-bold text-[#181C39] mt-2 ">
                            Planes en Gestión Publicitaria
                        </div>
                        <div className=" 2xl:text-base lg:text-sm text-xs text-[#181C39] mt-3 ">
                            Diseñamos campañas efectivas para aumentar tu
                            visibilidad y maximizar tus resultados.
                        </div>
                    </div>

                    <div className="py-5 px-5 rounded-2xl bg-white">
                        <img
                            className="h-12 w-12"
                            src={servicio_3}
                            alt="servicio_3"
                        />
                        <div className="xl:text-2xl lg:text-xl text-lg font-bold text-[#181C39] mt-2 ">
                            Manejo de Redes Sociales
                        </div>
                        <div className=" 2xl:text-base lg:text-sm text-xs text-[#181C39] mt-3 ">
                            Mejora tu presencia digital con contenido
                            estratégico y gestión profesional.
                        </div>
                    </div>
                    <div className="py-5 px-5 rounded-2xl bg-white">
                        <img
                            className="h-12 w-12"
                            src={servicio_4}
                            alt="servicio_4"
                        />
                        <div className="xl:text-2xl lg:text-xl text-lg font-bold text-[#181C39] mt-2 ">
                            Sesión Audiovisual
                        </div>
                        <div className=" 2xl:text-base lg:text-sm text-xs text-[#181C39] mt-3 ">
                            Creamos contenido visual impactante para potenciar
                            tu propiedad y atraer más clientes.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
